import axios from '../utils/axios';

const checkAuth = () => {
    const TOKEN = localStorage.getItem("token") || localStorage.getItem("accessToken")
    const currentPath = window.location.pathname;

    // 👇 THE FIX: Explicitly allow the root path ('/') and use exact path checking
    const isPublicPage = currentPath === '/' ||
        ['/login', '/forgot-password', '/register', '/documentation', '/share', '/reset-password', '/terms-of-service', '/privacy-policy', '/refund-policy', '/tools']
            .some(route => currentPath.startsWith(route));

    // If no token and they are NOT on a public page, kick them to login
    if (!TOKEN && !isPublicPage) {
        window.location.href = '/login';
        return;
    } else {
        // Only set the authorization header if a token actually exists
        if (TOKEN) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN.replace(/^"|"$/g, '')}`;
        }

        axios.interceptors.request.use(function (config) {
            return config
        }, function (error) {
            return Promise.reject(error);
        });

        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            return Promise.reject(error);
        });

        return TOKEN;
    }
}

export default checkAuth;